import React, { useState } from 'react';
import { Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { saveData } from '../services/api';

const RegistrationForm = ({ event }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    invitedBy: '',
    spouseFirstName: '',
    spouseLastName: '',
    eventId: event?.id || 'youth-bootcamp'
  });
  
  const [validated, setValidated] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    
    if (name === 'phone') {
      const digits = value.replace(/\D/g, '');
      if (digits.length <= 3) {
        newValue = digits;
      } else if (digits.length <= 6) {
        newValue = `${digits.slice(0, 3)}-${digits.slice(3)}`;
      } else {
        newValue = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
      }
    }
    
    setFormData(prevState => ({
      ...prevState,
      [name]: newValue
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    
    setIsSubmitting(true);
    setError(null);
    
    try {
      await saveData(formData);
      setSubmitted(true);
      setValidated(false);
      setFormData({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        invitedBy: '',
        spouseFirstName: '',
        spouseLastName: '',
        eventId: event?.id || 'youth-bootcamp'
      });
    } catch (err) {
      console.error('Error submitting form:', err);
      setError('Failed to submit registration. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <section className="py-3" id="register">
      <div className="card shadow">
        <div className="card-body p-4">
          <h2 className="text-center fw-bold mb-4">Register for {event?.title || 'Event'}</h2>
          <p className="text-center text-muted mb-4">{event?.subtitle} - {event?.dates}</p>
          
          {submitted && (
            <Alert variant="success" className="mb-4">
              <Alert.Heading>Registration Successful!</Alert.Heading>
              <p>Thank you for registering. We'll send a confirmation email shortly.</p>
              <div className="text-center mt-3">
                <Button as={Link} to="/" variant="outline-success">
                  Return to Home
                </Button>
              </div>
            </Alert>
          )}
          
          {error && !submitted && (
            <Alert variant="danger" className="mb-4">
              <Alert.Heading>Registration Error</Alert.Heading>
              <p>{error}</p>
            </Alert>
          )}
          
          {!submitted && (
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              {event?.id === 'couples-conference' && (
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Spouse First Name</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="spouseFirstName"
                        value={formData.spouseFirstName}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Spouse Last Name</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="spouseLastName"
                        value={formData.spouseLastName}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}
              
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  required
                  type="tel"
                  name="phone"
                  pattern="\d{3}-\d{3}-\d{4}"
                  placeholder="123-456-7890"
                  value={formData.phone}
                  onChange={handleChange}
                  maxLength={12}
                />
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  required
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>
              
              <Form.Group className="mb-4">
                <Form.Label>{event?.id === 'couples-conference' ? 'How did you hear about this conference?' : 'Who invited you?'}</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="invitedBy"
                  value={formData.invitedBy}
                  onChange={handleChange}
                  placeholder={event?.id === 'couples-conference' ? 'Pastor, friend, social media, etc.' : 'Name of person who invited you'}
                />
              </Form.Group>
              
              <div className="d-grid gap-2">
                <Button 
                  type="submit" 
                  variant={event?.id === 'couples-conference' ? 'primary' : 'warning'} 
                  size="lg" 
                  className="fw-bold"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : (event?.id === 'couples-conference' ? 'Register for Conference' : 'Reserve My Spot!')}
                </Button>
              </div>
            </Form>
          )}
        </div>
      </div>
    </section>
  );
};

export default RegistrationForm;